"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_GET_PROOF = exports.ERROR_GET_TRANSACTION = exports.ERROR_GET_PAYMENTS = exports.ERROR_CREATE_CLAIM_ADDRESSES = exports.ERROR_ADD_CLAIM_ADDRESS = exports.ERROR_GET_CLAIM_ADDRESSES = exports.ERROR_GET_KYC_STATUS = exports.ERROR_ACCEPT_TERMS = exports.ERROR_GET_TERMS = exports.ERROR_GETTING_START_DATE = void 0;
exports.ERROR_GETTING_START_DATE = 'ERROR_GETTING_START_DATE';
exports.ERROR_GET_TERMS = 'ERROR_GET_TERMS';
exports.ERROR_ACCEPT_TERMS = 'ERROR_ACCEPT_TERMS';
exports.ERROR_GET_KYC_STATUS = 'ERROR_GET_KYC_STATUS';
exports.ERROR_GET_CLAIM_ADDRESSES = 'ERROR_GET_CLAIM_ADDRESSES';
exports.ERROR_ADD_CLAIM_ADDRESS = 'ERROR_ADD_CLAIM_ADDRESS';
exports.ERROR_CREATE_CLAIM_ADDRESSES = 'ERROR_CREATE_CLAIM_ADDRESSES';
exports.ERROR_GET_PAYMENTS = 'ERROR_GET_PAYMENTS';
exports.ERROR_GET_TRANSACTION = 'ERROR_GET_TRANSACTION';
exports.ERROR_GET_PROOF = 'ERROR_GET_PROOF';
